import { MethodDataHandler } from "./MethodDataHandler";
import Controller from "../controller/Controller";
import { ApplePayMerchantCapability, ApplePayNetwork, ApplePayPaymentMethodData } from "./types/ApplePayPaymentMethodData";
import { PaymentMethodSpecificData } from "./types/PaymentMethodSpecificData";
import { PaymentRequestFactoryOptions } from "../types/SecurionPayOptions";
import { UserActionType } from "../types/UserAction";


export const APPLE_PAY_METHOD_ID = "https://apple.com/apple-pay";

export class ApplePayHandler implements MethodDataHandler {

    constructor(
        private readonly _controller: Controller,
        private readonly _options: PaymentRequestFactoryOptions,
    ) {
    }

    enhanceMethod(methodData: PaymentMethodData, paymentDetails: PaymentDetailsInit): void {
        if (!this.methodMatches(methodData)) {
            return
        }
        if (methodData.data === undefined) {
            methodData.data = {}
        }
        if (methodData.data.version === undefined) {
            methodData.data.version = 1
        }
        if (methodData.data.applicationData === undefined) {
            methodData.data.applicationData = btoa(window.location.hostname)
        }
        if (methodData.data.merchantCapabilities === undefined) {
            methodData.data.merchantCapabilities = [ApplePayMerchantCapability.supports3DS]
        }
        if (methodData.data.merchantIdentifier === undefined) {
            if (this._options.merchantId) {
                methodData.data.merchantIdentifier = `${this._options.merchantId}.merchant.dev.shift4.com`
            } else {
                methodData.data.merchantIdentifier = `${window.location.hostname}.dev.shift4.com`
            }
        }
        if (methodData.data.supportedNetworks === undefined) {
            methodData.data.supportedNetworks = [ApplePayNetwork.visa, ApplePayNetwork.masterCard]
        }

        const currency = paymentDetails?.total?.amount?.currency;
        if (!!currency && currency !== 'USD') {
            const supportedNetworks = methodData.data.supportedNetworks
              .filter(network => network !== ApplePayNetwork.discover)
            methodData.data = {
                ...methodData.data,
                supportedNetworks
            }
        }
    }

    enhancePaymentRequest(paymentRequest: PaymentRequest, methodData: PaymentMethodData[]) {
        const applePayData = methodData.find(this.methodMatches)
        if (!applePayData) {
            return;
        }

        paymentRequest['onmerchantvalidation'] = (event) => {
            const sessionRequest = {
                validationUrl: event.validationURL,
                merchantIdentifier: applePayData.data.merchantIdentifier
            };
            const session = this._controller.action(UserActionType.CREATE_APPLE_PAY_SESSION, sessionRequest)
                .then(response => {
                    if (response.error) {
                        console.error("Failed to create merchant session", response)
                        throw new Error(response.error.message || response.error)
                    } else {
                        return response.session;
                    }
                });
            event.complete(session)
        };
    }

    methodMatches = (method: PaymentMethodData): method is PaymentMethodSpecificData<ApplePayPaymentMethodData> => {
        return method && method.supportedMethods === APPLE_PAY_METHOD_ID;
    };

}